/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleBookingStatus } from './VehicleBookingStatus';
import {
    VehicleBookingStatusFromJSON,
    VehicleBookingStatusFromJSONTyped,
    VehicleBookingStatusToJSON,
    VehicleBookingStatusToJSONTyped,
} from './VehicleBookingStatus';

/**
 * 
 * @export
 * @interface VehicleBookingStatuses
 */
export interface VehicleBookingStatuses {
    /**
     * 
     * @type {Array<VehicleBookingStatus>}
     * @memberof VehicleBookingStatuses
     */
    items: Array<VehicleBookingStatus>;
}

/**
 * Check if a given object implements the VehicleBookingStatuses interface.
 */
export function instanceOfVehicleBookingStatuses(value: object): value is VehicleBookingStatuses {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function VehicleBookingStatusesFromJSON(json: any): VehicleBookingStatuses {
    return VehicleBookingStatusesFromJSONTyped(json, false);
}

export function VehicleBookingStatusesFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingStatuses {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(VehicleBookingStatusFromJSON)),
    };
}

export function VehicleBookingStatusesToJSON(json: any): VehicleBookingStatuses {
    return VehicleBookingStatusesToJSONTyped(json, false);
}

export function VehicleBookingStatusesToJSONTyped(value?: VehicleBookingStatuses | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(VehicleBookingStatusToJSON)),
    };
}

